import pushGTMEvent from '../../../util/helper/pushGTMEvent';

const configContents = ({ state: { langStrings, caseNumber }, dispatch }) => {
  return [
    {
      isTitle: true,
      hasSuccessMark: true,
      description: langStrings
        ? langStrings.contactOptions.caseSubmitted
        : 'Success',
      id: 'adsk-page-title',
    },
    {
      description: langStrings
        ? langStrings.contactOptions.caseNumber + caseNumber
        : `Case number: ${caseNumber}`,
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
        ? langStrings.contactOptions.caseConfirm1
        : 'You will receive an email confirmation shortly. If you do not receive an email, check your email junk/spam folder.',
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
        ? langStrings.contactOptions.caseConfirm2
        : 'An agent will review your case and get back to you within 2 business days.',
      paragraphStyle: { marginBottom: '20px' },
    },
  ];
}

const configFooter = ({ state: { userSession, hasExtension, langStrings }, dispatch }) => ({
  hasExtension,
  hideBackButton: true,
  nextButtonContent: langStrings
    ? langStrings.buttons.restartButton
    : 'RESTART',
  handleNext: () => {
    if(userSession) pushGTMEvent('ContactInfo');
    // Go to Welcome page.
    pushGTMEvent('Welcome');
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true);
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleChatInitialized: () => dispatch({ type: 'AGENT_INITIALIZED' }),
  handleChatStarted: () => dispatch({ type: 'GO_TO_AGENT_AVAILABLE_PAGE' }),
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-restart-button',
  handleBackButtonId: 'adsktm-cm-back-button',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
});

export default {
  configContents,
  configFooter,
};
